import { createSlotsContext } from "@grandvisionhq/slots";
const [StoreFinderSlotsProvider, useStoreFinderSlots] = createSlotsContext({
  displayName: "StoreFinderSlotsContext"
});
export {
  StoreFinderSlotsProvider,
  useStoreFinderSlots
};
//# sourceMappingURL=context.js.map
